import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { CompanySettingsService } from '../../core/services/company-settings.service';
import { CompanyInquiryStatistic } from '../../core/models/company-inquiry-statistic';

@Component({
  selector: 'app-inquiries-overview',
  templateUrl: './inquiries-overview.component.html',
  styleUrls: ['./inquiries-overview.component.scss'],
  providers: [CompanySettingsService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InquiriesOverviewComponent implements OnInit {
  displayedColumns: string[] = [
    'tenantId',
    'tenantIdentifier',
    'tenantName',
    'tenantConnectionString',
    'realmName',
    'inquiryLastDay',
    'inquiryLastWeek',
    'inquiryLastMonth',
  ];
  protected readonly dataSource = signal<CompanyInquiryStatistic[]>([]);

  constructor(private readonly companyService: CompanySettingsService) {}

  ngOnInit(): void {
    this.reloadCompanyAndTenantInfos();
  }

  reloadCompanyAndTenantInfos() {
    this.companyService
      .getCompanyInquiryStatistics()
      .subscribe((statistics) => {
        this.dataSource.set([...statistics]);
      });
  }
}
